import { LeaderboardPlayerData } from "../../models/leaderboard";

interface PlayerScorecardProps {
  player: LeaderboardPlayerData;
}
export function MatchPlayPlayerScorecard({ player }: PlayerScorecardProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 transition-colors duration-200">
      <div className="flex items-center mb-6">
        {player.profilePicture && (
          <img
            src={`/api/static/images/${player.profilePicture}`}
            alt={`${player.firstName} ${player.lastName}`}
            className="w-16 h-16 rounded-full mr-4"
          />
        )}
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            {player.firstName} {player.lastName}
          </h2>
          <div className="flex items-center mt-1 space-x-4">
            <span className="text-gray-600 dark:text-gray-400">
              Points: {player.totalPoints}
            </span>
            {/* <span className="text-gray-600 dark:text-gray-400">
              W/L/S: {player.finalResult?.wins}/{player.finalResult?.losses}/
              {player.finalResult?.draws}
            </span> */}
          </div>
          {player.matchResult &&
            player.matchResult.length > 0 &&
            player.matchResult?.map((score: any) => (
                <div key={score.opponentPlayerId} className="px-4 py-3">
                <p className="font-semibold text-gray-900 dark:text-gray-100">
                  vs: {score.opponent.firstName} {score.opponent.lastName}
                </p>
                {/* {!score.isMatchComplete && (
                  <p className="text-gray-700 dark:text-gray-300">
                  W/L/S: {score.wins}/{score.losses}/{score.draws}
                  </p>
                )} */}

                <p className="text-gray-600 dark:text-gray-400">{score.matchResult}</p>
                </div>
            ))}
        </div>
      </div>
    </div>
  );
}
